import React from 'react';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { useTranslation } from 'react-i18next';
import { Box, Typography, useTheme } from '@mui/material';
import CampaignDataGrid from './components/campaign-data-grid';
import CampaignExportButton from './components/campaign-export-button';
import { exportCampaigns } from 'services/campaign.service';
import { useAppDispatch, useAppSelector } from 'common/hook';
import CampaignConstants from './constants';
import { handleError } from 'utils/helpers';
import { RootState } from 'plugins/store';
import { setIsLoading } from 'slices/loadingSlice';

const Campaign: React.FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();

    const campaignsSearchForm = useAppSelector(
        (state: RootState) => state.campaignState.campaignsSearchForm
    );
    const dispatch = useAppDispatch();

    const handleExport = async () => {
        try {
            dispatch(setIsLoading(true));
            const params = { ...campaignsSearchForm };
            if (
                campaignsSearchForm.campaignType?.includes(
                    CampaignConstants.service.ALL
                )
            ) {
                params.campaignType = [];
            }
            if (
                campaignsSearchForm.status?.includes(
                    CampaignConstants.status.ALL
                )
            ) {
                params.status = [];
            }
            const excelData = await exportCampaigns({
                page: 1,
                q: {
                    search_with_key_cont: params.searchKeyWord,
                    status_client_in: params.status?.join(','),
                    service_kind_in: params.campaignType?.join(','),
                    start_date: params.startDate,
                    end_date: params.endDate,
                },
            });
            // Get the filename from Content-Disposition header if available
            const filename = 'campaigns.xlsx';

            // Create blob URL and trigger download
            const url = window.URL.createObjectURL(new Blob([excelData]));
            const link = document.createElement('a');
            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();

            // Clean up
            document.body.removeChild(link);
            setTimeout(() => {
                window.URL.revokeObjectURL(url);
                dispatch(setIsLoading(false));
            }, 100);
        } catch (error) {
            handleError(error);
            dispatch(setIsLoading(false));
        }
    };
    return (
        <Box mt={'50px'}>
            <Box mb={'40px'}>
                <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="end"
                >
                    <Typography
                        variant="h3"
                        component="h3"
                        fontSize={28}
                        fontWeight={'bold'}
                        lineHeight={'34px'}
                        color={theme.palette.primary.main}
                    >
                        {t('page.campaign.title')}
                    </Typography>
                    <CampaignExportButton onClick={handleExport} />
                </Box>
            </Box>
            <Card
                elevation={0}
                sx={{
                    borderRadius: '26px',
                }}
            >
                <CardContent
                    sx={{
                        padding: 0,
                        paddingBottom: '0 !important',
                    }}
                >
                    <CampaignDataGrid />
                </CardContent>
            </Card>
        </Box>
    );
};

export default Campaign;
